/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-array-method-this-argument */
/* eslint-disable unicorn/no-array-callback-reference */
/* eslint-disable no-console */
import { Events } from '../../utils/dom/html-events';
import Manipulator from '../../utils/dom/manipulator';
import Request, { ApiMode } from '../../utils/request';
import EventHandler from '../../utils/dom/event-handler';
import { ClassNames } from '../../utils/dom/css-classes';
import SelectorEngine from '../../utils/dom/selector-engine';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const IS_LOCAL = false;

const SELECTOR_MAIN_DIV = '.js-competition-profile-landing-page-wrapper';
const SELECTOR_LINKED_COMPETITION_MEMBERS = '.js-competion-profile__member-details';
const SELECTOR_COMPETITION_PROFILE_PAGE_ERROR_CONTAINER = '.js-competition-profile-page__error-container';
const SELECTOR_COMPETITION_PROFILE_MEMBER_DETAIL_MISSIONG_ERROR_CONTAINER =
	'.js-competition-profile__member-details-error-container';

class CompetionProfileLandingPage {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_MAIN_DIV);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get membersData() {
		return this._membersData;
	}

	set membersData(data) {
		this._membersData = data;
		if (this._membersData.length > 0) {
			this.renderCompetitionMemberList(data);
		}
	}

	init() {
		this.linkedCompetitionMemberDetails = SelectorEngine.findOne(SELECTOR_LINKED_COMPETITION_MEMBERS, this._wrapper);

		this.getCompetitionMemberDetailsUrl = Manipulator.getDataAttribute(this._wrapper, 'get-competition-member-details-url');

		// error container selectors
		this.competitionProfileErrorContainer = SelectorEngine.findOne( SELECTOR_COMPETITION_PROFILE_PAGE_ERROR_CONTAINER, this._wrapper);
		this.memberDetailsMissingErrorContainer = SelectorEngine.findOne(SELECTOR_COMPETITION_PROFILE_MEMBER_DETAIL_MISSIONG_ERROR_CONTAINER, this._wrapper);

		this.competitionProfileErrorText = SelectorEngine.findOne('.error-text', this.competitionProfileErrorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this.competitionProfileErrorContainer);

		if (this._closeErrorSnackBar) {
			EventHandler.on(this._closeErrorSnackBar, Events.Click, () => {
				this.competitionProfileErrorContainer.classList.add(ClassNames.Hidden);
			});
		}

		this.fetchLinkedMemberDetails();

		this.enterCompetitionBtn = SelectorEngine.findOne('.js-enter-competition-btn', this._wrapper);

		if (this.enterCompetitionBtn) {
			EventHandler.on(this.enterCompetitionBtn, Events.Click, (e) => this.handleEnterCompetitionClick(e));
		}
	}

    handleEnterCompetitionClick(e) {
        const missingMembers = this._membersData?.filter(
            (m) => m.status?.toLowerCase() === 'details missing'
        );

        // if no missing members, allow redirect
        if (!missingMembers || missingMembers.length === 0) {
            this.memberDetailsMissingErrorContainer.classList.add(ClassNames.Hidden);
            return;
        }

        // stop redirect if missing details exist
        e.preventDefault();

        // show top error container
        this.memberDetailsMissingErrorContainer.classList.remove(ClassNames.Hidden);

        // highlight missing member cards
        const memberCards = SelectorEngine.find('lta-competition-profile-member-card', this._wrapper);

        memberCards.forEach((card) => {
            const status = card.getAttribute('data-member-status')?.toLowerCase();
            const missingText = SelectorEngine.findOne('.missing-details-text', card);

            if (status === 'details missing') {
                card.classList.add('has-error');
                if (missingText) missingText.classList.remove(ClassNames.Hidden);

                card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                card.classList.remove('has-error');
                if (missingText) missingText.classList.add(ClassNames.Hidden);
            }
        });
    }


	// fetching member details
    async fetchLinkedMemberDetails() {
		startLoadingAnimation(true);
		try {
			const url = this.getCompetitionMemberDetailsUrl;
			const response = await Request.get(url, {}, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { success, errorMessage, memberDetails } = response;
			stopLoadingAnimation();
			if (!success) {
				this.showErrorContainer(errorMessage || 'Something went wrong');
				this.membersData = [];
				return;
			}
			this.membersData = [...memberDetails];
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

    // fetching member details error handling
	showErrorContainer(message) {
		this.competitionProfileErrorContainer.classList.remove(ClassNames.Hidden);
		this.competitionProfileErrorText.innerHTML = message;
		this.competitionProfileErrorContainer.scrollIntoView({
			behavior: 'smooth',
			block: 'center'
		});
	}

	renderCompetitionMemberList(membersData) {
		if (!this.linkedCompetitionMemberDetails) return;
		this.linkedCompetitionMemberDetails.innerHTML = membersData.map((item, index) => this.renderMembersData(item, index)).join('');
	}

    // used lta-competeion-profile-member-card web components for showing member details
	renderMembersData(member) {
		const details = member.details || [];

		const detailAttrs = details
			.map((d, i) => {
				return `
                data-detail-${i}-label="${d.label}"
                data-detail-${i}-value="${d.value}"
                data-detail-${i}-type="${d.type}"
                data-detail-${i}-order="${d.order}"
            `;
			})
			.join(' ');

		return `
            <lta-competition-profile-member-card
                data-member-id="${member.id}"
                data-member-sfid="${member.sfid}"
                data-member-firstname="${member.firstName}"
                data-member-lastname="${member.lastName}"
                data-member-status="${member.status || ''}"
                data-details-count="${details.length}"
                data-show-edit-details-button="${member?.showEditDetailsButton || false}"
                data-edit-button-link="${member.editDetailButtonInfo?.link}"
                data-edit-button-icon="${member.editDetailButtonInfo?.icon}"
                data-edit-button-label="${member.editDetailButtonInfo?.label}"

                ${detailAttrs}
            >
            </lta-competition-profile-member-card>
        `;
	}
}

const globalCompetionProfileLandingPage = new CompetionProfileLandingPage();
export default globalCompetionProfileLandingPage;
